import { chunk, difference, intersection, isEqual } from "lodash";

type BatchEntryResetAction = {
  type: "reset";
};

type UpdateEntryIdsAction<EntryT> = {
  type: "update_required_entry_ids";
  entryIds: EntryT[];
};

const MAX_ENTRY_IDS_PER_REQUEST = 128;

export function BatchEntryReducer<EntryT>(
  state: EntryT[][],
  action: BatchEntryResetAction | UpdateEntryIdsAction<EntryT>,
) {
  switch (action.type) {
    case "reset": {
      if (state.length === 0) return state;
      return [];
    }
    case "update_required_entry_ids": {
      // remove requests no longer needed
      const filteredState = state.filter(
        (entryIds) => intersection(action.entryIds, entryIds).length > 0,
      );
      // add new entry ids
      const missingEntryIds = difference(action.entryIds, filteredState.flat());
      const newState = filteredState.concat(
        chunk(missingEntryIds.sort(), MAX_ENTRY_IDS_PER_REQUEST),
      );

      return isEqual(newState, state) ? state : newState;
    }
  }
  throw new Error(`unexpected action type: ${action}`);
}
